var PICK_UP_POINTS_PATH = "/company/:companyOid/pickupPoint/";
var PICK_UP_POINT_PATH = "/company/:companyOid/pickupPoint/:oid/";

angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(PICK_UP_POINTS_PATH, {
        templateUrl: 'assets/pickupPoint/index.html',
        controller: 'PickupPointsController',
        title: 'pickupPoint.TITLE',
        sidebar: 'company'
    });
}]);


angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(PICK_UP_POINT_PATH, {
        templateUrl: 'assets/pickupPoint/edit.html',
        controller: 'PickupPointController',
        title: 'pickupPoint.TITLE',
        sidebar: 'company'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/pickupPoint_route.js
// module id = 817
// module chunks = 3